import { Locale } from './locale';
import { Latlong } from './latlong';

export class Geolocation {
  public requestPref: string = '';
  public locale: Locale = new Locale();
  public latLong: any = new Latlong();
  public locationType: string = '';
  public locShortName: string = '';
}
